import styled from '@emotion/styled';

const flexContainerProps = [
  'flex-direction',
  'flex-wrap',
  'flex-flow',
  'justify-content',
  'align-items',
  'align-content'
];

const flexItemProps = [
  'order',
  'flex-grow',
  'flex-shrink',
  'flex-basis',
  'flex',
  'align-self'
];

const structFlexProps = [
  // Flex Container Props
  ...flexContainerProps,

  // Flex Item Props
  ...flexItemProps
];

const generateProps = (props: any, type: any[]) => {
  let flexProps = '';

  flexProps += props.flex
    ? null
    : `flex: 
    ${props.grow || props['flex-grow'] || 0}
    ${props.shrink || props['flex-shrink'] || 1}
    ${props.basis || props['flex-basis'] || 'auto'};`;

  for (const prop in props) {
    if (prop) {
      const idx =
        type.indexOf(prop) > -1
          ? type.indexOf(prop)
          : type.indexOf('flex-'.concat(prop)) > -1
          ? type.indexOf('flex-'.concat(prop))
          : -1;

      if (idx > -1) {
        flexProps += `${type[idx]}: ${props[prop]};`;
      }
    }
  }

  return flexProps;
};

export const StructFlex = styled('div')`
  display: flex;
  ${props => generateProps(props, structFlexProps)};
`;

export const StructItem = styled('div')`
  ${props => generateProps(props, flexItemProps)};
`;
